/* eslint-disable import/no-anonymous-default-export */
export default {
  "header.title": {
    en: "Gold",
    mr: "गोल्ड",
    hi: "गोल्ड",
    gu: "ગોલ્ડ",
  },
  "header.logout": {
    en: "Exit",
    mr: "बाहेर पडा",
    hi: "बाहर जाएं",
    gu: "બહાર નીકળો",
  },
  // *********************************************************************************
  "footer.tncLinks": {
    en: "https://www.corporate.agrostar.in/goldtnc-en",
    mr: "https://www.corporate.agrostar.in/goldtnc-mr",
    hi: "https://www.corporate.agrostar.in/goldtnc-hi",
    gu: "https://www.corporate.agrostar.in/goldtnc-gj",
  },
  "footer.agrostar": {
    en: "About AgroStar",
    mr: "अ‍ॅग्रोस्टार बद्दल",
    hi: "एग्रोस्टार के बारे में",
    gu: "એગ્રોસ્ટાર વિશે",
  },
  "footer.agrostarGold": {
    en: "More about AgroStar Gold",
    mr: "अ‍ॅग्रोस्टार गोल्ड बद्दल आजून माहिती",
    hi: "एग्रोस्टार गोल्ड के बारे में अधिक जानकारी",
    gu: "એગ્રોસ્ટાર ગોલ્ડ વિશે વધુ માહિતી",
  },
  "footer.tearmsAndCondtions": {
    en: "Terms and Conditions",
    mr: "नियम आणि अटी",
    hi: "नियम और शर्तें",
    gu: "નિયમો અને શરતો",
  },
  "footer.call": {
    en: "Need help? Contact us here",
    mr: "मदत पाहिजे? आमच्याशी संपर्क येथे साधा",
    hi: "मदद की ज़रूरत है? हमें संपर्क करें",
    gu: "મદદ ની જરૂર છે ? અહી અમારો સંપર્ક કરો",
  },
  "footer.supportNumber": {
    en: "+912067186720",
    mr: "+912067186720",
    hi: "+912067186768",
    gu: "+917966774445",
  },
  "footer.language": {
    en: "Change language",
    mr: "भाषा बदला",
    hi: "भाषा बदलें",
    gu: "ભાષા બદલો",
  },
  // *********************************************************************************
  "share.dialog.title": {
    en: "Share on Social Media",
    mr: "सोशल मीडिया वर शेअर करा",
    hi: "Share on Social Media",
    gu: "Share on Social Media",
  },
  // *********************************************************************************
  "cropPage.cropList.sectionTitle": {
    en: "See other crops",
    mr: "इतर पिके पहा",
    hi: "अन्य फसल देखें",
    gu: "બીજા પાક જુવો",
  },
  "cropPage.crops.video": {
    en: "Video",
    mr: "विडीओ",
    hi: "विडीओ",
    gu: "વિડિઓ",
  },
  "cropPage.crops.videos": {
    en: "Videos",
    mr: "विडीओ",
    hi: "विडीओ",
    gu: "વિડિઓ",
  },
  // *********************************************************************************
  "landing.title1": {
    en: "Now higher yield",
    mr: "आता कमी खर्चात",
    hi: "अब कम खर्च में",
    gu: "હવે ઓછા ખર્ચે માં",
  },
  "landing.title2": {
    en: "at a lesser expense",
    mr: "उत्पादन ज्यादा",
    hi: "उत्पादन ज़्यादा",
    gu: "ઉત્પાદન વધુ",
  },
  "landing.title3": {
    en: "AgroStar Gold: Online progressive farming guidance",
    mr: "अ‍ॅग्रोस्टार गोल्ड: ऑनलाइन प्रगतशील शेती मार्गदर्शन",
    hi: "अ‍ॅग्रोस्टार गोल्ड: ऑनलाइन प्रगतिशील खेती मार्गदर्शन",
    gu: "એગ્રોસ્ટાર ગોલ્ડ: ઓનલાઇન પ્રગતિશીલ ક્રુશી માર્ગદર્શન",
  },
  "landing.aboutAgroStar": {
    en: "With changing times, progressive farming should be even more readily available to farmers of our country. AgroStar Gold is a premium technology-enabled service offering, exclusively made for you. Through this service, you can now become a progressive farmer with the online guidance of AgroStar's Agri Experts. ",
    mr: "अ‍ॅग्रोस्टार गोल्ड एक प्रीमियम तंत्रज्ञान-सक्षम सेवा आहे, जी खास आपल्यासाठी बनवली आहे. आता अ‍ॅग्रोस्टारचे अ‍ॅग्री एक्सपर्ट्स ऑनलाइनव्दारे आपल्याला प्रगतीशील शेतीचे मार्गदर्शन  देतील.",
    hi: "एग्रस्टार गोल्ड एक प्रीमियम तकनीक-सक्षम सेवा है, जो ख़ास आपके लिए बनायी गयी है। अब एग्रोस्टार के एग्री एक्सपर्ट ऑनलाइन के माध्यम से प्रगतिशील खेती के लिए आपका मार्गदर्शन करेंगे।",
    gu: "એગ્રોસ્ટાર ગોલ્ડ એ તમારા માટે એક પ્રીમિયમ તકનીક-સક્ષમ સેવા છે. હવે એગ્રોસ્ટારના એગ્રી એક્સપર્ટ ઓનલાઈન દ્વારા તમને પ્રગતિશીલ ખેતી માટે માર્ગદર્શન આપશે.",
  },
  "landing.subTitle": {
    en: "Scientific farming for more productivity & profitability with minimum farm inputs",
    mr: "आमचा संकल्प, आपल्या पिकांची देखभाल, ज्यामुळे शेती राहील प्रगतशील व  कुटुंब खुशहाल!",
    hi: "हमारा संकल्प, आपकी फसलों का देखभाल करना, ताकि कृषि प्रगतिशील रहे और परिवार खुशहाल रहे!",
    gu: "અમારો સંકલ્પ, તમારા પાકનું ઓછા ખર્ચે વધુ ઉત્પાદન અને નફાકારક ખેતી. જેથી ખેડૂત  પ્રગતિશીલ રહે અને કુટુંબ પણ સુખી રહે!",
  },
  "landing.titleButton": {
    en: "Learn more",
    mr: "अधिक जाणून घ्या",
    hi: "और अधिक जानें",
    gu: "વધારે જાણો",
  },
  "landing.joinNow": {
    en: "join now!",
    mr: "आत्ताच सामील व्हा!",
    hi: "अभी ज्वाइन करें!",
    gu: "હમણાં જ જોડાવ!",
  },
  "landing.callMe": {
    en: "Want more information?",
    mr: "अधिक माहिती हवी आहे?",
    hi: "अधिक जानकारी चाहते हैं?",
    gu: "વધુ માહિતી જોઈએ છે?",
  },
  "landing.tryFree": {
    en: "Join Gold classes now",
    mr: "आत्ताच सामील व्हा गोल्ड क्लास मध्ये",
    hi: "अभी भाग ले गोल्ड क्लास मैं",
    gu: "હવે ગોલ્ડ વર્ગોમાં જોડાઓ",
  },
  "landing.namaste": {
    en: "Namaste!",
    mr: "नमस्कार!",
    hi: "नमस्ते!",
    gu: "નમસ્તે!",
  },
  "landing.description": {
    en: "Having served 25 lakh farmers already, AgroStar combines technology, scientific methods of farming & personalized region and weather based expertise and brings to you - AgroStar Gold - a new way to learn the best farming practices from the best Agri-Experts in India online, from the comfort of your home! Join online classes, learn from our Agri-Experts and get a higher yield at lower expenses starting today.",
    mr: "25 लाखाहून अधिक शेतकऱ्यांना शेती मध्ये उत्पादन वाढीसाठी हातभार लावला असून आता अ‍ॅग्रोस्टार तंत्रज्ञान, शाश्त्रशुद्ध पद्धतीने, आपल्या वैयक्तिक, प्रादेशिक व हवामानाच्या माहितीवर आधारित शेतीचे ज्ञान आपल्यास सादर करीत आहे - अ‍ॅग्रोस्टार गोल्ड या रूपात. भारतातील सर्वोत्कृष्ट कृषी तज्ञांकडून ऑनलाईन क्लास मध्ये घर-बसल्या शिका आणि आपल्या शेतमालाचे उत्पादन हमखास वाढवा, तेही कमी खर्चात!",
    hi: "अभी तक 25 लाख किसानों की सेवा करने के बाद, एग्रोस्टार टेक्नोलॉजी, व्यक्तिगत क्षेत्र, खेती के वैज्ञानिक तरीकों और मौसम पर आधारित विशेषज्ञता को जोड़ते हुए आपके लिए लाया है - एग्रोस्टार गोल्ड - अपने घर पर आराम से, भारत में सबसे अच्छे अग्रि एक्सपर्ट्स से ऑनलाइन खेती के सर्वोत्तम तरीकों को सीखने का एक नया तरीका! आज ही ऑनलाइन क्लासेस में शामिल हों, हमारे अग्रि-एक्सपर्ट्स से सीखें और कम खर्चे में अधिक उपज प्राप्त करें।",
    gu: "એગ્રોસ્ટાર અત્યાર સુધીમાં 25 લાખ જેટલા ખેડુતોને આધુનિક ટેકનોલોજી, વૈજ્ઞાનિક ખેતી પધ્ધતી અને જુદા જુદા વિસ્તાર પ્રમાણે વાતાવરણ આધારીત તમામ ટેકનિકલ સવલત પુરી પાડેલ છે.  એગ્રોસ્ટાર ગોલ્ડ- એક નવીન તેમજ ઉમદા અભીગમ છે જેમાં ઓનલાઈન પ્લેટફોર્મ દ્વારા ખેતીને લગતી સારામાં સારી પધ્ધતીઓ તમને એગ્રી નિષ્ણાત દ્વારા સમગ્ર ભારતભરમાં આપવામાં આવે છે જેનો લાભ ઘર બેઠા લઈ સરળતાથી લઈ શકાય તેમ છે. તો ચાલો ઓનલાઈન ક્લાસમાં જોડાવીને અને આપણા એગ્રી ડોક્ટરને મળીને ઓછો ખેતી ખેર્ચ કરી વધુ ઉત્પાદન મેળવીએ.",
  },
  "landing.agrostarGold": {
    en: "What is AgroStar Gold?",
    mr: "अ‍ॅग्रोस्टार गोल्ड काय आहे?",
    hi: "एग्रोस्टार गोल्ड क्या है?",
    gu: "એગ્રોસ્ટાર ગોલ્ડ શું છે?",
  },
  "landing.whatYouGet": {
    en: "What you will get?",
    mr: "आपण यातून काय मिळवणार?",
    hi: "आपको क्या मिलेगा?",
    gu: "તમને શું મળશે?",
  },
  "landing.msg1.title": {
    en: "Online classes: ",
    mr: "ऑनलाइन क्लास: ",
    hi: "ऑनलाइन क्लास: ",
    gu: "ઓનલાઈન ક્લાસ: ",
  },
  "landing.msg1.text": {
    en: "Online classes by our agri-experts for every stage for 40+ crops' lifecycle based on the latest technology, weather information, agronomy and market studies",
    mr: "तंत्रज्ञान, हवामान, कृषी-शास्त्र आणि बाजारपेठाच्या अभ्यासाच्या बळावर कृषी तज्ज्ञांकडून 40 हून अधिक पिकांसाठी मार्गदर्शन.",
    hi: "तकनीक, मौसम, कृषि विज्ञान और बाजार अध्ययन के आधार पर कृषि विशेषज्ञों द्वारा 40 से अधिक फसलों के लिए मार्गदर्शन।",
    gu: "ટેકનોલોજી, હવામાન, કૃષિવિજ્ઞાન અને બજારના અભ્યાસના આધારે કૃષિ નિષ્ણાતો દ્વારા 40 થી વધુ પાક માટે માર્ગદર્શન.",
  },

  "landing.msg2.title": {
    en: "Live Video Calling: ",
    mr: "लाइव्ह व्हिडिओ कॉलिंग: ",
    hi: "लाइव वीडियो कॉलिंग: ",
    gu: "લાઇવ વિડિઓ કોલિંગ: ",
  },
  "landing.msg2.text": {
    en: "Reach out to our Agri experts from your farms through live video calling to discuss any current issues or problems in your crops",
    mr: "शेतातील कोणत्याही समस्या सोडवण्यासाठी थेट व्हिडिओ कॉलिंगद्वारे तज्ञांशी संभाषण.",
    hi: "खेत में किसी भी समस्या को हल करने के लिए लाइव वीडियो कॉलिंग के माध्यम से विशेषज्ञों के साथ बातचीत",
    gu: "ખેતરમાં કોઈપણ સમસ્યાનું સમાધાન કરવા માટે લાઇવ વિડિઓ કોલિંગ દ્વારા નિષ્ણાતો સાથે વાતચીત કરવી.",
  },
  "landing.msg3.title": {
    en: "Guidance Videos:",
    mr: "मार्गदर्शन व्हिडिओ: ",
    hi: "मार्गदर्शन वीडियो: ",
    gu: "માર્ગદર્શન વિડિઓ: ",
  },
  "landing.msg3.text": {
    en: "Get access to a complete set of videos on progressive farming practices to manage your crop well at any stage",
    mr: "प्रगतीशील शेतीसाठी पिकांच्या संपूर्ण नियोजनाचे खास मार्गदर्शन व्हिडीओ.",
    hi: "प्रगतिशील खेती के लिए पूरी फसल योजना पर विशेष मार्गदर्शन वीडियो",
    gu: "પ્રગતિશીલ ખેતી માટેની સંપૂર્ણ પાક યોજના પર વિશેષ માર્ગદર્શન વિડિઓ",
  },
  "landing.farmerProfit": {
    en: "Benefits other farmers got",
    mr: "शेतकर्‍यांना झालेला फायदा",
    hi: "अन्य किसानों को लाभ मिला",
    gu: "ખેડુતોને લાભ",
  },
  "landing.profit1": {
    en: "Boost in crop quality",
    mr: "पिकाच्या गुणवत्तेत सुधारणा",
    hi: "फसल की गुणवत्ता में सुधार",
    gu: "પાકની ગુણવત્તામાં સુધારો",
  },

  "landing.profit2": {
    en: "Increase in yield",
    mr: "पिकाच्या उत्पन्नात वाढ",
    hi: "फसल की पैदावार में वृद्धि",
    gu: "પાકના ઉત્પાદન માં વધારો",
  },

  "landing.profit3": {
    en: "Reduction in costs",
    mr: "पिकांसाठी  होणारा खर्च कमी",
    hi: "फसलों के लिए लागत मे कमी",
    gu: "પાક માટે ખર્ચમાં ઘટાડો",
  },

  "landing.join25K": {
    en: "Join 25K+ farmers who benefited with AgroStar Gold",
    mr: "अ‍ॅग्रोस्टार गोल्डचा फायदा घेतलेल्या 25000 हून ही अधिक शेतकर्‍यांच्या गटामध्ये सामील व्हा",
    hi: " एग्रोस्टार गोल्ड का लाभ उठाने वाले २५००० से भी अधिक किसानों से जुड़ें",
    gu: "250000 થી વધુ ખેડુતોમાં જોડાઓ જેમણે એગ્રોસ્ટાર ગોલ્ડનો લાભ લીધો છે",
  },
  "landing.whatOurFarmerSays": {
    en: "See what our farmers have to say",
    mr: "आमचे शेतकरी काय बोलतात ते पहा",
    hi: "देखिए हमारे गोल्ड किसान क्या कहते हैं",
    gu: "જુવો ! અમારા ખેડૂતો શું કહે છે",
  },
  "landing.startNow": {
    en: "Get started today!",
    mr: "आजच प्रारंभ करा!",
    hi: "आज ही जुड़े!",
    gu: "આજે પ્રારંભ કરો!",
  },
  "landing.cropTitle": {
    en: "Online guidance for 40+ crops",
    mr: "40+ पिकांसाठी ऑनलाईन मार्गदर्शन",
    hi: "40+ फसलों के लिए ऑनलाइन मार्गदर्शन",
    gu: "40+ પાક માટે ઓનલાઇન માર્ગદર્શન",
  },
  "landing.cropDetail": {
    en: "Available in Maharashtra only",
    mr: "अ‍ॅग्रोस्टार गोल्ड सेवा सध्या फक्त महाराष्ट्रातील शेतकऱ्यांसाठी; इतर राज्यात आम्ही खूपच लवकर येत आहोत",
    hi: "केवल महाराष्ट् में",
    gu: "ફક્ત મહારાષ્ટ્રમાં ઉપલબ્ધ ",
  },
  "landing.seeMoreCrops": {
    en: "See more crops",
    mr: "आणखी पिके पाहण्यासाठी",
    hi: "और फसल देखें",
    gu: "વધુ પાક જુવો",
  },
  "landing.seeLessCrops": {
    en: "See less crops",
    mr: "मोजकी पिके पाहण्यासाठी",
    hi: "कम फसल देखें",
    gu: "ઓછા પાક જુવો",
  },

  "landing.offerMonths": {
    en: " months",
    mr: " महिन्यांसाठी",
    hi: " महीने के लिए ",
    gu: " મહિના માટે",
  },
  "landing.freebiesTextStart": {
    en: "Buy now and get medicines worth ",
    mr: "आत्ताच खरेदी करा आणि ",
    hi: "अभी खरीदें और ",
    gu: "હમણાં જ ખરીદો અને મેળવો ",
  },
  "landing.freebiesTextEnd": {
    en: "delivered to your home FREE",
    mr: "ची औषधे FREE (मोफत) मिळवा, तेही घरापर्यंत डिलिव्हरीसोबत",
    hi: "की दवाएँ FREE (मुफ्त) पाएं और उनकी होम डिलीवरी भी पाएं",
    gu: "ની કિંમતની દવાઓ FREE તમારા ઘરે",
  },
  "landing.limitedOffer": {
    en: "Limited time offer",
    mr: "ऑफर मर्यादित वेळेसाठी",
    hi: "ऑफर सीमित समय तक",
    gu: "મર્યાદિત સમયની ઓફર ",
  },
  "landing.offerPoints1Start": {
    //6 monthly offer - 30% Savings
    en: "",
    mr: "आमच्या ",
    hi: "हमारे",
    gu: "અમારી",
  },
  "landing.offerPoints1Months": {
    en: "monthly",
    mr: "महिन्यांच्या ",
    hi: "महीने की",
    gu: "મહિનાની",
  },
  "landing.offerPoints1OfferText": {
    en: "offer - ",
    mr: "ओफरवर ",
    hi: "ऑफर पर ",
    gu: "ઓફર દ્વારા ",
  },
  "landing.offerPoints1End": {
    en: "savings",
    mr: "ची बचत",
    hi: "की बचत करें",
    gu: "બચાવો",
  },
  "landing.offerPoints2Start": {
    en: "Unlimited access to all live classes of all crops for ",
    mr: "मिळावा सर्व पिकांच्या सर्व लाईव्ह क्लास मध्ये प्रवेश ",
    hi: "सभी फसलों के ऑनलाइन कक्षाओं के लिए असीमित उपयोग ",
    gu: "મળશે! બધાજ  પાકના બધાજ લાઈ વ ક્લાસમાં પ્રવેશ ",
  },
  "landing.offerPoints2Months": {
    en: "months",
    mr: "महिन्यांसाठी",
    hi: "महीने के लिए",
    gu: "મહિના સુધી",
  },
  "landing.offerPoints3": {
    en: "Join an elite group of farmers practicing scientific farming and do progressive farming with reduced cost!",
    mr: "वैज्ञानिक शेतीचा अभ्यास करणाऱ्या एका अभिजात गटामध्ये सामील व्हा (आणि) कमी किमतीत प्रगतशील शेती करा!",
    hi: "वैज्ञानिक खेती करने वाले किसानों के अभिजात समूह में शामिल हों और कम लागत के साथ प्रगतिशील खेती करें!",
    gu: "વૈજ્ઞાનિક ખેતી કરતા સર્વોત્તમ ખેડૂતોના ગ્રુપ સાથે જોડાવ અને ઓછા ખર્ચે પ્રગતિશીલ ખેતી કરો",
  },
  "landing.offerPoints4": {
    en: "Live problem solving",
    mr: "तत्पर समस्या निराकरण कृषी-तज्ञांसोबत ",
    hi: "अग्रि एक्सपर्ट्स के साथ समस्या का समाधान लाइव पाएं",
    gu: "તાત્કાલિક સમસ્યાનું નિવારણ",
  },
  "landing.offerPoints5": {
    en: "",
    mr: "इतर शेतकरी कशा पद्धतीची शेती करतात आणि कोणत्या समस्यांना तोंड देत आहेत ते जाणून सुद्धा घ्या",
    hi: "सीखे दूसरे किसान कैसे खेती कर रहे हैं और वे किन समस्याओं का सामना कर रहे हैं",
    gu: "જાણો! બીજા ખેડૂત કેવી રીતે ખેતી કરે છે અને તેઓ કયા સમસ્યાનો  સામનો કરી રહ્યા છે",
  },
  "landing.offerPoints6": {
    en: "Complete refund within 30 days if you aren't satisfied",
    mr: "जर आपल्याला सेवा समाधानकारक वाटली नाही तर 30 दिवसात पूर्ण पैसे परत!",
    hi: "पसंद ना आने पर 30 दिनों में पैसे वापस ",
    gu: "જો આપ 30 દિવસ સુધીમાં સંતુસ્ટ નથી તો આપે આપેલી સંપુર્ણ રકમ પરત કરવામાં આવશે",
  },
  "landing.wantToJoinCall": {
    en: "Want to know more?",
    mr: "अधिक जाणून घ्यायचे आहे का?",
    hi: "और जानना है इस बारें में?",
    gu: "આ વિશે વધુ જાણવા માંગો છો?",
  },

  // *********************************************************************************
  "login.login": {
    en: "Log In",
    mr: "लॉग इन करा",
    hi: "लॉग इन करें",
    gu: "લોગ ઇન કરો",
  },
  "login.loginOneStep": {
    en: "Log in with just 2 steps & get started",
    mr: "एका टप्यात लॉग-इन करा आणि अ‍ॅग्रोस्टार गोल्ड वापरण्यास सुरु करा!",
    hi: "बस एक चरण में लोग-इन करें और एग्रोस्टार गोल्ड का उपयोग शुरू करें!",
    gu: "ફક્ત એક પગલામાં લ લોગ-ઇન કરો અને એગ્રોસ્ટાર ગોલ્ડનો ઉપયોગ શરૂ કરો!",
  },
  "login.form.name": {
    en: "Name",
    mr: "नाव",
    hi: "नाम",
    gu: "નામ",
  },
  "login.form.mobile": {
    en: "Mobile number",
    mr: "मोबाइल नंबर",
    hi: "मोबाइल नंबर",
    gu: "મોબાઇલ નંબર",
  },
  "login.form.state": {
    en: "State",
    mr: "राज्य निवडा",
    hi: "राज्य चुनीये",
    gu: "રાજ્ય",
  },
  "join.form.mobileValidation": {
    en: "e.g. 7966774445",
    mr: "जसे की 7966774445",
    hi: "जैसे की 7966774445",
    gu: "દાખ્લા તરીકે 7966774445",
  },
  "login.form.remember": {
    en: "Remember Me",
    mr: "मला विसरू नका", // "आठवणीत ठेवा",
    hi: "मुझे याद रखना",
    gu: "મને યાદ કરાવો",
  },
  "login.form.submit": {
    en: "Enter",
    mr: "प्रवेश करा",
    hi: "प्रवेश करें",
    gu: "પ્રવેશ કરો ",
  },
  "login.form.couldNotFindAccount": {
    en: "We could not find your account",
    mr: "आपला प्रोफाइल आम्हाला मिळाला नाही",
    hi: "हमें आपका अकाउंट नहीं मिल रहा",
    gu: "અમે તમારું એકાઉન્ટ શોધી શક્યા નહીં",
  },
  "login.form.registerHere": {
    en: "Please register here",
    mr: "येथे क्लिक करून प्रोफाइल बनवा",
    hi: "कृपया यहाँ रजिस्टर करें",
    gu: "કૃપા કરી અહીં નોંધણી કરો",
  },
  // *********************************************************************************
  "signup.signout": {
    en: "Sign Out",
    mr: "बाहेर पडा",
    hi: "बाहर जाएं",
    gu: "બહાર નીકળો",
  },
  "signup.welcome": {
    en: "Welcome to AgroStar Gold!",
    mr: "अ‍ॅग्रोस्टार गोल्ड मध्ये आपले स्वागत आहे!",
    hi: "एग्रोस्टार गोल्ड में आपका स्वागत है!",
    gu: "એગ્રોસ્ટાર ગોલ્ડ માં આપનું સ્વાગત છે!",
  },
  "signup.comingSoon": {
    en: "Coming Soon!",
    mr: "अ‍ॅग्रोस्टार गोल्ड सध्या फक्त महाराष्ट्रातच उपलब्ध आहे, पण अ‍ॅग्रोस्टार गोल्ड मधील आपली रुची पाहून आम्हाला खूप आनंद झाला. जेव्हा आम्ही आपल्या राज्यात अ‍ॅग्रोस्टार गोल्ड आणू, तेव्हा आम्ही नक्की आपल्याशी संपर्क साधू.",
    hi: "एग्रोस्टार गोल्ड फिलहाल महाराष्ट्र में उपलब्ध है। लेकिन, एग्रोस्टार गोल्ड में आपकी रुचि देखके हम बहोत उत्साहित हैं। जब भी हम आपके राज्य में लॉन्च करेंगे तो हम आपसे जरूर संपर्क करेंगे! ",
    gu: "Coming Soon!",
  },
  "signup.signup": {
    en: "Sign Up",
    mr: "साइन अप करा",
    hi: "साइन अप करें",
    gu: "સાઈન અપ",
  },
  "signup.profileSetupStepper": {
    en: "Profile Setup",
    mr: "प्रोफाइल सेटअप",
    hi: "प्रोफ़ाइल सेटअप",
    gu: "પ્રોફાઇલ સેટઅપ",
  },
  "signup.paymentStepper": {
    en: "Payment",
    mr: "देय",
    hi: "पेमेंट",
    gu: "ચુકવણી",
  },
  "signup.payAndContinue": {
    en: "Pay & get access instantly",
    mr: "पेमेंट करा आणि वापरण्यास प्रारंभ करा",
    hi: "पेमेंट करें और उपयोग करना शुरू करें",
    gu: "ચુકવણી ચૂકવો અને ઉપયોગ શરૂ કરો",
  },

  "signup.sendOtpAgain": {
    en: "Send OTP again?",
    mr: "पुन्हा ओटीपी पाठवा?",
    hi: "OTP फिर से भेजें?",
    gu: "ફરીથી OTP મોકલો?",
  },
  "signup.enterOtpSentTo": {
    en: "Enter the OTP Code sent to",
    mr: "ओटीपी (OTP) इथे टाका, जो या नंबर वर पाठवला आहे- ",
    hi: "ओटीपी (OTP) कोड को दर्ज करें, जो इस नंबर पर भेजा गया है- ",
    gu: "ઓટીપી (OTP) દાખલ કરો, જે આ નંબર પર મોકલવામાં આવે છે-",
  },
  "signup.optional": {
    en: "Optional",
    mr: "अनिवार्य नाही",
    hi: "अनिवार्य नहीं है",
    gu: "વૈકલ્પિક",
  },
  "signup.unlimitedAccess": {
    en: "Get unlimited access to all live & pre-recorded classes",
    mr: "अनलिमिटेड उपलब्धता सर्व लाईव्ह आणि परी-रेकॉर्डेड क्लासेस ची",
    hi: "सभी लाइव और प्री-रिकॉर्डेड क्लासेस की अनलिमिटेड पहुँच पाएं",
    gu: "બધા જ લાઇવ અને પહેલાં રેકોર્ડ કરેલ ક્લાસમાં અમર્યાદિત પ્રવેશ મેળવો",
  },
  "signup.classWaiting": {
    en: "Your Gold Classes are waiting",
    mr: "गोल्ड क्लास आपली प्रतीक्षा करत आहेत",
    hi: "आपकी गोल्ड क्लासेस आपका इंतजार कर रही हैं",
    gu: "તમારા ગોલ્ડ કલાસ તમારી રાહ જોઈ રહ્યા છે",
  },
  "signup.createProfile": {
    en: "Create your profile in just 2 steps & get started",
    mr: "फक्त 2 टप्प्यात आपले प्रोफाइल तयार करा आणि प्रारंभ करा",
    hi: "केवल 2 चरणों में अपना प्रोफ़ाइल बनाएं और आरंभ करें",
    gu: "ફક્ત 2 પગલામાં તમારી પ્રોફાઇલ બનાવો અને પ્રારંભ કરો",
  },
  "signup.userExists": {
    en: "User with this mobile number already exists",
    mr: "हा मोबाईल नंबर अ‍ॅग्रोस्टार गोल्ड वर आधीच वापरात आहे",
    hi: "इस मोबाइल नंबर के साथ एक यूजर पहले से मौजूद है",
    gu: "આ મોબાઇલ નંબરના વપરાશકર્તા પહેલાથી અસ્તિત્વમાં છે",
  },
  "signup.invalidMobile": {
    en: "Please provide valid mobile number.",
    mr: "कृपया वैध मोबाईल नंबर द्या",
    hi: "कृपया वैध मोबाइल नंबर दीजिये",
    gu: "કૃપા કરી માન્ય મોબાઇલ નંબર પ્રદાન કરો.",
  },
  "signup.tncStart": {
    en: "By clicking on this button you agree with our",
    mr: `"सत्यापित करा" क्लिक करून आपण आमच्या `,
    hi: `"सत्यापित करें" पर क्लिक करके आप हमारे `,
    gu: `"પ્રમાણિત કરો " પર  ક્લિક કરીને તમે અમારા `,
  },
  "signup.tncText": {
    en: `Terms & Conditions`,
    mr: `अटी व शर्तींशी `,
    hi: `नियमों और शर्तों से `,
    gu: `નિયમો અને શરતોથી `,
  },
  "signup.tncEnd": {
    en: "",
    mr: "सहमत होता",
    hi: "सहमत होते हैंं",
    gu: "સંમત થાઓ છો",
  },
  "signup.otpDialogContinue": {
    en: "Continue",
    mr: "पुढे जा",
    hi: "सुरु ठेवा",
    gu: "ચાલુ રાખો",
  },
  "signup.membershipDetails": {
    en: "Your GOLD membership details",
    mr: "आपले गोल्ड सदस्यता तपशील",
    hi: "आपकी गोल्ड सदस्यता की जानकारी",
    gu: "તમારી ગોલ્ડ સબ્સ્ક્રિપ્શન વિગતો",
  },
  "signup.duration": {
    en: "Duration",
    mr: "कालावधी",
    hi: "अवधि",
    gu: "અવધિ",
  },
  "signup.months": {
    en: "Months",
    mr: "महीने",
    hi: "महीने ",
    gu: "મહિના",
  },
  "signup.validTill": {
    en: "Valid till",
    mr: "वैध",
    hi: "वैधता",
    gu: "સુધી માન્ય",
  },
  "signup.billSummary": {
    en: "Bill Summary",
    mr: "बिल सारांश",
    hi: "बिल सारांश",
    gu: "બિલ સારાંશ",
  },
  "signup.subTotal": {
    en: "Subtotal",
    mr: "एकूण",
    hi: "उप-योग",
    gu: "કુલ",
  },
  "signup.total": {
    en: "Total",
    mr: "एकूण",
    hi: "कुल",
    gu: "કુલ",
  },
  "signup.discount": {
    en: "Discount",
    mr: "सवलत",
    hi: "छूट",
    gu: "ડિસ્કાઉન્ટ",
  },
  "signup.paymentSuccess": {
    en: "Payment was successful",
    mr: "देय यशस्वी झाले!",
    hi: "पेमेंट सफल हुआ",
    gu: "ચુકવણી સફળ થઈ!",
  },
  "signup.addedInFamily": {
    en: "We are happy to have you as a part of this growing family",
    mr: "आपल्या मोफत ऑफरबद्दल आम्ही तुम्हाला लवकरच कॉल करून अधिक माहिती देऊ आणि आपल्या या नवीन अ‍ॅग्रोस्टार गोल्ड सदस्यतेचा पुरेपूर उपभोग कसा घ्यावा हे देखील सांगू. अ‍ॅग्रोस्टार गोल्ड च्या सोई-सुविधा वापरण्यास लगेच सुरुवात करा आणि क्लासमध्ये सामील नक्की व्हा!",
    hi: "हमारी टीम आपको आपके फ्री ऑफर की और जानकारी देने के लिए कॉल करेगी और एग्रोस्टार गोल्ड से अधिक लाभ कैसे उठा सकते है इसकी भी जानकारी देगी। तुरंत एग्रोस्टार गोल्ड की सुविधाओं का उपयोग करना शुरू करें और लाइव क्लासेज में शामिल होये!",
    gu: "અમે આ વિકસતા પરિવારનો ભાગ બનીને ખુશ છીએ",
  },
  "signup.verifyWithOtp": {
    en: "Verify with OTP",
    mr: "ओटीपी (OTP) द्वारे सत्यापित करा",
    hi: "ओटीपी डालें",
    gu: "ઓટીપી સાથે ચકાસો",
  },
  "signup.otpVerificationFail": {
    en: "OTP verification failed",
    mr: "ओटीपी द्वारे सत्यापन अयशस्वी",
    hi: "ओटीपी गलत है",
    gu: "ઓટીપી ચકાસણી નિષ્ફળ",
  },
  "signup.inputCorrectOtp": {
    en: "Please input the correct OTP and retry",
    mr: "कृपया बरोबर ओटीपी टाकून पुन्हा प्रयत्न करा",
    hi: "कृपया सही OTP इनपुट करें और पुनः प्रयास करें",
    gu: "કૃપા કરીને સાચો ઓટીપી દાખલ કરો અને ફરીથી પ્રયાસ કરો",
  },
  "signup.retrySendingOtp": {
    en: "Please retry by resending OTP",
    mr: "ओटीपी पुन्हा मिळवून प्रयत्न करा",
    hi: "कृपया OTP को पुनः प्राप्त करके फिर से प्रयास करें",
    gu: "કૃપા કરી ઓટીપી ફરી મોકલો અને ફરીથી પ્રયાસ કરો",
  },
  "free.classWaiting": {
    en: "Gold Classes are waiting for you",
    mr: "गोल्ड क्लास आपली प्रतीक्षा करत आहेत",
    hi: "गोल्ड क्लासेस आपका इंतजार कर रही हैं",
    gu: "ગોલ્ડ કલાસ તમારી રાહ જોઈ રહ્યો છે",
  },
  "free.createProfile": {
    en: "Get started with just 1 step",
    mr: "फक्त 1 टप्प्यात प्रारंभ करा",
    hi: "केवल 1 चरण में शुरू करें",
    gu: "ફક્ત 1 પગલામાં પ્રારંભ કરો",
  },
  "free.signup": {
    en: "Join Gold classes",
    mr: "सामील व्हा गोल्ड क्लास मध्ये",
    hi: "भाग ले गोल्ड क्लास मैं",
    gu: "ગોલ્ડ વર્ગોમાં જોડાઓ",
  },
  "free.whyGold": {
    en: "What you get with AgroStar Gold?",
    mr: "अ‍ॅग्रोस्टार गोल्डमध्ये आपल्याला काय मिळेल?",
    hi: "आपको एग्रोस्टार गोल्ड से क्या मिलेगा?",
    gu: "તમને એગ્રોસ્ટાર ગોલ્ડની સેવામાં શું મળશે?",
  },

  "free.whyGoldReason1": {
    en: "Get higher yield and lower farming cost",
    mr: "आपल्या पिकांसाठी  मिळवा उत्पादनात वाढ आणि खर्चात बचत",
    hi: "अधिक उपज और कम खेती लागत प्राप्त करें",
    gu: "ઓછા ખર્ચે સારી ઉપજ મેળવો",
  },
  "free.whyGoldReason2": {
    en: "Attend live classes & doubt clearing for all crops.",
    mr: "थेट ऑनलाईन शेती शाळा आणि प्रश्न-उत्तर चर्चा सत्रामध्ये सामील व्हा",
    hi: "सभी फसलों के लिए लाइव क्लासेस या प्रश्न समाशोधन में भाग लें",
    gu: "કોઈપણ સમયે કોઈપણ પાકના અગાઉના રેકોર્ડ કરેલા વર્ગો જુઓ",
  },
  "free.whyGoldReason3": {
    en: "Watch past classes and content anytime for all crops",
    mr: "वर्गाचे सर्व व्हिडिओ रेकॉर्डिंग आपल्या सवडीनुसार पहा",
    hi: "किसी भी फसल की पिछली रिकार्डेड क्लासेज किसी भी समय देखे",
    gu: "કોઈપણ સમયે કોઈપણ પાકના અગાઉના રેકોર્ડ કરેલા વર્ગો જુઓ",
  },
  // *********************************************************************************
  "dashboard.live.sectionTitle": {
    en: "Online classes",
    mr: "ऑनलाइन क्लासेस",
    hi: "ऑनलाइन क्लासेस",
    gu: "ઓનલાઈન કલાસ્સેસ",
  },
  "dashboard.liveHelp.sectionTitle": {
    en: "Video Calling",
    mr: "व्हिडिओ कॉलिंग",
    hi: "वीडियो कॉलिंग",
    gu: "વિડિઓ કોલિંગ",
  },
  "dashboard.howToUse.sectionTitle": {
    en: "How to use zoom?",
    mr: "क्लास मध्ये सामील कसे व्हायचे?",
    hi: "झूम का उपयोग कैसे करें?",
    gu: "ઝૂમનો ઉપયોગ કેવી રીતે કરવો?",
  },
  "dashboard.liveHelp.cardTitle": {
    en: "Live Help",
    mr: "लाईव्ह चर्चा/मदत",
    hi: "लाइव चर्चां",
    gu: "લાઈવ ચર્ચા",
  },
  "dashboard.liveHelp.join": {
    en: "Join",
    mr: "सामील व्हा",
    hi: "शामिल होंं",
    gu: "જોડાઓ",
  },
  "dashboard.liveHelp.upcoming": {
    en: "Upcoming",
    mr: "आगामी",
    hi: "आगामी",
    gu: "આગામી",
  },
  "dashboard.liveHelp.description": {
    en: "Join a live- discussion with our Agri-Experts and clarify your doubts",
    mr: "झूम चर्चासत्रात कधीही सामील व्हा आणि तज्ञांना आपले प्रश्न विचारा.",
    hi: "हमारे अग्रि-एक्सपर्ट्स के साथ एक लाइव-चर्चा में शामिल हों और अपने प्रश्नो का उत्तर पाएं  ",
    gu: "અમારા એગ્રિ-ડોકટરો સાથે જીવંત ચર્ચામાં જોડાઓ અને તમારા શંકાઓને સ્પષ્ટ કરો",
  },
  "dashboard.liveHelp.ongoing": {
    en: "Ongoing",
    mr: "चालू राहिल",
    hi: "जारी रहेगा",
    gu: "ચાલુ રહેશે",
  },
  "dashboard.liveHelp.till": {
    en: "till",
    mr: "पर्यंत",
    hi: "तक",
    gu: "સુધી",
  },
  "dashboard.live.byAuthor": {
    en: "Agri Expert. ",
    mr: "कृषी तज्ञ ",
    hi: "अग्रि एक्स्पर्ट ",
    gu: "એગ્રી એક્સપર્ટ ",
  },
  "dashboard.live.noSession1": {
    en: "There are no ongoing classes right now. Please check 'Upcoming classes' for the schedule. See you at ",
    mr: "सध्या कोणताही क्लास चालू नाही. कृपया 'आगामी क्लास' मध्ये वेळापत्रक पाहा. आपण ",
    hi: "अभी कोई लाइव क्लासेस नहीं है। कृपया शेड्यूल के लिए 'आगामी क्लासेस' देखे. हम ",
    gu: "અત્યારે કોઈપણ ચર્ચા સત્ર ચાલુ નથી.કૃપા કરી 'આગામી ચર્ચાસત્ર' દ્વારા સમય પત્રક ચકાસો. અમે ",
  },
  "dashboard.live.noSession2": {
    en: " ",
    mr: " वाजता भेटूयात!",
    hi: " बजे मिलेंगे!",
    gu: " પર મળીશું!",
  },
  "dashboard.live.noSessionNoUpcoming": {
    en: " ",
    mr: "  लवकरच भेटूयात!!",
    hi: " जल्दी मिलेंगे!",
    gu: " ટૂંક સમયમાં મળીશું!",
  },
  "dashboard.live.tomorrow": {
    en: " tomorrow",
    mr: " उद्या",
    hi: " कल",
    gu: " આવતીકાલે",
  },
  "dashboard.live.dayAfterTomorrow": {
    en: " day after tomorrow",
    mr: " परवा",
    hi: " परसो",
    gu: " બપોરે",
  },
  "dashboard.live.twoDaysAfterTomorrow": {
    en: " after two days",
    mr: " दोन दिवसांनी",
    hi: " दो दिन बाद",
    gu: " બે દિવસ પછી",
  },
  "dashboard.upcoming.sectionTitle": {
    en: "All upcoming classes",
    mr: "सर्व आगामी क्लास",
    hi: "आगामी क्लासेस",
    gu: "આગામી ચર્ચાસત્ર",
  },
  "dashboard.upcoming.noSession": {
    en: "There are no upcoming classes. Please check again soon!",
    mr: "सध्या कोणताही क्लास नियोजित नाही. कृपया थोड्या वेळानी परत पहा!",
    hi: "कोई आगामी क्लासेस नहीं हैं। कृपया जल्द ही फिर से देखे!",
    gu: "હાલમાં કોઈ ચર્ચાસત્ર નું આયોજન નથી.  કૃપા કરીને ટૂંક સમયમાં ફરીથી તપાસો!",
  },
  agrostargold: {
    en: "AgroStar Gold - ",
    mr: "अ‍ॅग्रोस्टार गोल्ड - ",
    hi: "एग्रोस्टार गोल्ड - ",
    gu: "એગ્રોસ્ટાર ગોલ્ડ - ",
  },
  "dashboard.upcoming.shareText": {
    en: "Join at",
    mr: "सामील व्हा",
    hi: "शामिल होये",
    gu: "અહી જોડાવો",
  },
  "dashboard.recording.sectionTitle": {
    en: "Recorded classes",
    mr: "रेकॉर्ड केलेले क्लास",
    hi: "रेकॉर्डेड क्लास",
    gu: "રેકોર્ડ કરેલો વર્ગ ",
  },
  "dashboard.recording.shareText": {
    en: "Watch recorded classes",
    mr: "संग्रहित क्लास ",
    hi: "रिकार्डेड क्लासेस देखें",
    gu: "રેકોર્ડ કરેલ ચર્ચા-સત્ર",
  },
  "dashboard.live.successStoriesTitle": {
    en: "Success Stories",
    mr: "यशोगाथा",
    hi: "सफलता की कहानियां",
    gu: "સફળતા ની કહાની ",
  },
  "dashboard.cropsList.sectionTitle": {
    en: "See Classes by Crops",
    mr: "पिकानुसार क्लासचे रेकॉर्डिंग पहा",
    hi: "फसल अनुसार क्लासेस देखे",
    gu: "પાક દ્વારા વર્ગો જુઓ",
  },
  "dashboard.live.joinButton": {
    en: "Join LIVE Class",
    mr: "लाईव्ह क्लास मध्ये सामील व्हा",
    hi: "LIVE क्लास ज्वाइन करें",
    gu: "લાઇવ ક્લાસમાં જોડાવ",
  },
  "dashboard.welcomeMessage.title": {
    en: "Welcome!",
    mr: "आपले स्वागत आहे!",
    hi: "आपका स्वागत है!",
    gu: "તમારું સ્વાગત છે!",
  },
  "dashboard.welcomeMessage.body": {
    en: "Here Agrostar Agri-Experts will guide you online for progressive farming.",
    mr: "अ‍ॅग्रोस्टार कृषी तज्ञ आपल्याला येथे प्रगतीशील शेतीसाठी ऑनलाइन मार्गदर्शन करेल.",
    hi: "एग्रोस्टार कृषि तज्ञ यहाँ आपको प्रगतिशील खेती के लिए ऑनलाइन मार्गदर्शन देंगे ",
    gu: "એગ્રોસ્ટારના એગ્રી એક્સપર્ટ તમને અહીં પ્રગતિશીલ ખેતી માટે માર્ગદર્શન આપશે.",
  },
  "dashboard.welcomeMessage.explore": {
    en: "Explore",
    mr: "गोल्डचा अनुभव घ्या",
    hi: "गोल्ड का उपयोग करें",
    gu: "ગોલ્ડનું અનુભવ કરો",
  },
  "dashboard.welcomeMessage.howToUse": {
    en: "Start using now.",
    mr: "सुरु करूया",
    hi: "शुरू करें",
    gu: "શરૂઆત",
  },
  "dashboard.leadRegistrationSuccess.message": {
    en: "Thank you for showing your interest! Someone from AgroStar will give you a call soon.",
    mr: "आपली आवड दर्शविल्याबद्दल धन्यवाद! अ‍ॅग्रोस्टारमधील कोणीतरी लवकरच आपल्याला कॉल करेल.",
    hi: "अपनी रुचि दिखाने के लिए धन्यवाद! एग्रोस्टारसे कोई आपको जल्द ही कॉल करेगा।",
    gu: "તમારી રુચિ બતાવવા બદલ આભાર! એગ્રોસ્ટારમાંથી કોઈ તમને ટૂંક સમયમાં કોલ કરશે.",
  },
  "dashboard.leadRegistrationSuccess.okay": {
    en: "Okay",
    mr: "ठीक आहे",
    hi: "ठीक है",
    gu: "ઠીક છે",
  },
  "dashboard.free.wantToSeeMore": {
    en: "Want to see more classes?",
    mr: "अधिक क्लास पाहायचे आहेत?",
    hi: "और क्लास देखना चाहते हो?",
    gu: "વધુ કલાસ જોવા માંગો છો?",
  },
  "dashboard.free.joinUs": {
    en: "Call us now!",
    mr: "आम्हाला कॉल करा",
    hi: "हमें कॉल करें",
    gu: "અમને કોલ કરો",
  },

  "help.cta.question.signup": {
    en: "Have trouble signing up?",
    mr: "सामील होण्यात अडचणी?",
    hi: "अकाउंट बनाने में परेशानी हो रही है?",
    gu: "એકાઉન્ટ બનાવવામાં મુશ્કેલી આવી રહી છે?",
  },
  "help.cta.question.payment": {
    en: "Have trouble signing up?",
    mr: "कृषी-तज्ञांशी गोल्ड बद्दल बोलायचे आहे?",
    hi: "हमारे अग्रि-एक्सपर्ट्स से गोल्ड के बारे में बात करना चाहते हैं?",
    gu: "અમારા કૃષિ નિષ્ણાત સાથે ગોલ્ડ સર્વિસ ની વાત કરવા માંગો છો?",
  },
  "help.cta.button.text": {
    en: "Call Us",
    mr: "आम्हाला कॉल करा",
    hi: "हमें कॉल करें",
    gu: "અમને કોલ કરો",
  },
  "dashboard.remindMe.buttonText": {
    en: "I want to attend",
    mr: "मला सामील व्हायचे आहे",
    hi: "मैं भाग लेना चाहता हूँं",
    gu: "હું જોડાવા માંગુ છું",
  },
  "dashboard.seatReserved.buttonText": {
    en: "Seat reserved!",
    mr: "आपली जागा निश्चित!",
    hi: "आपकी जगह निश्चित!",
    gu: "તમારું સ્થાન નિશ્ચિત!",
  },
  "landing.pricingSubtitle1": {
    en: "Use the Free AgroStar Gold premium service",
    mr: "अ‍ॅग्रोस्टार गोल्डची प्रीमियम सेवा",
    hi: "एग्रोस्टार गोल्ड की प्रीमियम सेवा का",
    gu: "એગ્રોસ્ટાર ગોલ્ડની પ્રીમિયમ સેવાનો",
  },
  "landing.pricingSubtitle2": {
    en: "for 30 days.",
    mr: "३० दिवसांसाठी विनामूल्य वापरा.",
    hi: "30 दिनों के लिए निःशुल्क उपयोग करें।",
    gu: "30 દિવસ માટે નિઃશુલ્ક ઉપયોગ કરો.",
  },
  "referalcard.title": {
    en: "Membership & Activity Details",
    mr: "सदस्यता आणि क्रियाकलाप तपशील",
    hi: "सदस्यता और गतिविधि विवरण",
    gu: "સભ્યપદ અને પ્રવૃત્તિ વિગતો",
  },
  "referralcard.title": {
    en: "Profile & Subscription",
    mr: "प्रोफाइल आणि सदस्यता",
    hi: "प्रोफ़ाइल और सदस्यता",
    gu: "પ્રોફાઇલ અને સબ્સ્ક્રિપ્શન",
  },

  "referralcard.invitetext": {
    en: "Invite your friends to AgroStar Gold and earn upto 200 AgroStar Cash per successful referral",
    mr: "आपल्या मित्रांना अ‍ॅग्रोस्टार गोल्डमध्ये आमंत्रित करा आणि प्रति यशस्वी रेफरल साठी 200 अ‍ॅग्रोस्टार कॅश मिळवा.",
    hi: "अपने दोस्तों को एग्रोस्टार गोल्ड में आमंत्रित करें और प्रति सफल रेफरल पर 200 एग्रोस्टार कॅश पाएं",
    gu: "તમારા મિત્રોને એગ્રોસ્ટાર ગોલ્ડમાં આમંત્રણ આપો અને દરેક સફળ રેફરલ માટે 200 એગ્રોસ્ટાર કેશ મેળવો",
  },
  "referralcard.addfriendsbuttontext": {
    en: "Invite Friends",
    mr: "मित्रांना आमंत्रित करा",
    hi: "मित्रों को आमंत्रित करें",
    gu: "મિત્રોને આમંત્રિત કરો",
  },
  "referralcard.refernearnHeading": {
    en: "Refer & earn",
    mr: "रेफर करा आणि कमवा",
    hi: "रेफर करें और कमाएँ",
    gu: "રેફર કરો અને કમાવ",
  },
  "referralcard.freemium": {
    en: "Freemium",
    mr: "फ्री ट्रायल",
    hi: "फ्री ट्रायल",
    gu: "ફ્રી ટ્રાયલ",
  },
  "referralcard.active": {
    en: "Active",
    mr: "सक्रिय",
    hi: "सक्रिय",
    gu: "સક્રિય",
  },
  "referralcard.startDate": {
    en: "Start Date",
    mr: "प्रारंभ तारीख",
    hi: "प्रारंभ तिथि",
    gu: "પ્રારંભ તારીખ",
  },
  "referralcard.endDate": {
    en: "End Date",
    mr: "शेवटची तारीख",
    hi: "समाप्ति तिथि",
    gu: "અંતિમ તારીખ",
  },
  "referralcard.goldEnding": {
    en: "Your AgroStar Gold Subscription is ending",
    mr: "आपली अ‍ॅग्रोस्टार गोल्ड सदस्यता समाप्त होत आहे",
    hi: "आपकी एग्रोस्टार गोल्ड सदस्यता समाप्त हो रही है ",
    gu: "તમારી એગ્રોસ્ટાર ગોલ્ડ સભ્યપદ સમાપ્ત થઈ રહ્યું છે",
  },
  "referralcard.renewSubscription": {
    en: "Renew Subscription",
    mr: "सदस्यता सुरू ठेवा",
    hi: "सदस्यता जारी रखे",
    gu: "સભ્યપદ ચાલુ રાખો",
  },
  "referralcard.expiringSoon": {
    en: "Expiring Soon",
    mr: "सदस्यता संपत आहे",
    hi: "सदस्यता समाप्त हो रही है ",
    gu: "સભ્યપદ સમાપ્ત થઈ રહ્યું છે",
  },
  "referralcard.classesAttended": {
    en: "Classes attended",
    mr: "Classes attended",
    hi: "ऑनलाइन क्लास्सेस में भाग लिया",
    gu: "Classes attended",
  },
  "referralcard.qnaAttended": {
    en: "Q&A Attended",
    mr: "Q&A Attended",
    hi: "कृषि विशेषज्ञ के साथ वीडियो कॉलिंग",
    gu: "Q&A Attended",
  },
  "referralcard.refernEarn": {
    en: "Refer & earn",
    mr: "रेफर करा आणि कमवा",
    hi: "रेफर करें और कमाएँ",
    gu: "Refer & earn",
  },
  "referralcard.inviteFriendsnEarn": {
    en: "Invite your friends to AgroStar Gold and earn upto 200 AgroStar Cash per successful referral",
    mr: "आपल्या मित्रांना अ‍ॅग्रोस्टार गोल्डमध्ये आमंत्रित करा आणि प्रति यशस्वी रेफरल साठी 200 अ‍ॅग्रोस्टार कॅश मिळवा.",
    hi: "अपने दोस्तों को एग्रोस्टार गोल्ड में आमंत्रित करें और प्रति सफल रेफरल पर 200 एग्रोस्टार कॅश पाएं ",
    gu: "તમારા મિત્રોને એગ્રોસ્ટાર ગોલ્ડમાં આમંત્રણ આપો અને દરેક સફળ રેફરલ માટે 200 એગ્રોસ્ટાર કેશ મેળવો.",
  },
  "referralcard.inviteFriends": {
    en: "Invite Friends",
    mr: "मित्रांना आमंत्रित करा",
    hi: "मित्रों को आमंत्रित करें",
    gu: "મિત્રોને આમંત્રિત કરો",
  },
  "referralcard.learnMore": {
    en: "Learn More",
    mr: "अधिक जाणून घ्या",
    hi: "अधिक जानें",
    gu: "વધુ શીખો",
  },
  agrostartGold: {
    en: "AgroStar Gold",
    mr: "अ‍ॅग्रोस्टार गोल्ड",
    hi: "अ‍ॅग्रोस्टार गोल्ड",
    gu: "એગ્રોસ્ટાર ગોલ્ડ",
  },
  profilenSubscription: {
    en: "Profile & Subscription",
    mr: "प्रोफाइल आणि सदस्यता",
    hi: "प्रोफ़ाइल और सदस्यता",
    gu: "પ્રોફાઇલ અને સબ્સ્ક્રિપ્શન",
  },
  "referralcard.expireinxDays": {
    en: "Renew in X days",
    mr: "सदस्यता X दिवसात अपडेट करा",
    hi: "सदस्यता X दिनों में अपडेट करें",
    gu: "સભ્યપદ X દિવસમાં અપડેટ કરો",
  },
  "referralcard.renewtext": {
    en: "Renew Subscription",
    mr: "सदस्यता सुरू ठेवा",
    hi: "सदस्यता जारी रखे",
    gu: "સભ્યપદ ચાલુ રાખો",
  },
  "referralcard.plan": {
    en: "AgroStar Gold",
    mr: "गोल्ड सदस्यता",
    hi: "गोल्ड सदस्यता",
    gu: "ગોલ્ડ સબ્સ્ક્રિપ્શન",
  },
  "referralcard.expired": {
    en: "Expired",
    mr: "सदस्यता संपले",
    hi: "सदस्यता समाप्त",
    gu: "સભ્યપદ સમાપ્ત",
  },
  "referralcard.expiredLine": {
    en: "Your AgroStar Gold membership has expired",
    mr: "आपली अ‍ॅग्रोस्टार गोल्ड सदस्यता समाप्त झाली आहे",
    hi: "आपकी एग्रोस्टार गोल्ड सदस्यता समाप्त हो गयी है",
    gu: "તમારી એગ્રોસ્ટાર ગોલ્ડ સભ્યપદ સમાપ્ત થઈ ગઈ છે",
  },
  "cropPage.contentVideo.sectionTitle": {
    en: "Videos By Topic",
    mr: "विषयानुसार व्हिडिओ",
    hi: "विषय अनुसार वीडियो",
    gu: "વિષય દ્વારા વિડિઓઝ",
  },
  "cropPage.contentVideo.seeMore": {
    en: "See More Videos",
    mr: "अधिक व्हिडिओ पहा",
    hi: "और वीडियो देखें",
    gu: "વવધુ વિડિઓઝ જુઓ",
  },
  "cropPage.contentVideo.shareText": {
    en: "I found interesting videos on AgroStar Gold for my crop. AgroStar Agri Experts in these videos talk about various different topics and solutions. You will find it helpful! Check it out here ",
    mr: " पिकासाठी मला अ‍ॅग्रोस्टर गोल्ड वर एक उपयुक्त व्हिडिओ मिळाला आहे. या व्हिडिओमध्ये ऍग्रोस्टार कृषी तज्ञ वेगवेगळ्या विषयांवर आणि उपायांवर चर्चा करतात. आपल्याला ते उपयुक्त वाटेल! हा व्हिडिओ पहा  ",
    hi: " फसल के लिए मुझे एग्रोस्टार गोल्ड पर एक उपयोगी वीडियो मिला। इस वीडियो में कृषि तज्ञ विभिन्न विषयों और समाधानों पर चर्चा करते हैं। आप इसे उपयोगी पाएंगे! इस वीडियो को देखें ",
    gu: " પાક માટે મને એગ્રોસ્ટર ગોલ્ડ પર એક ઉપયોગી વિડિઓ મળી. આ વિડિઓમાં, એગ્રોસ્ટાર કૃષિ નિષ્ણાતો વિવિધ વિષયો અને ઉકેલોની ચર્ચા કરે છે. તમને તે ઉપયોગી થશે! આ વિડિઓ જુઓ ",
  },
  "cropPage.contentVideo.shareTextWeather": {
    en: "I found interesting videos on AgroStar Gold for my crop. AgroStar Agri Experts in these videos talk about various different topics and solutions. You will find it helpful! Check it out here ",
    mr: " साठी अ‍ॅग्रोस्टर गोल्ड वर एक उपयुक्त व्हिडिओ मिळाला आहे. या व्हिडिओमध्ये ऍग्रोस्टार कृषी तज्ञ वेगवेगळ्या विषयांवर आणि उपायांवर चर्चा करतात. आपल्याला उपयुक्त ठरेल! हा व्हिडिओ पहा ",
    hi: " के लिए मुझे एग्रोस्टार गोल्ड पर एक उपयोगी वीडियो मिला। इस वीडियो में कृषि विशेषज्ञ विभिन्न विषयों और समाधानों पर चर्चा करते हैं। आपको यह उपयोगी लगेगा! इस वीडियो को देखें ",
    gu: " માટે મને એગ્રોસ્ટાર ગોલ્ડ પર એક ઉપયોગી વિડિઓ મળી. આ વિડિઓમાં એગ્રોસ્ટાર કૃષિ નિષ્ણાતો વિવિધ વિષયો અને ઉકેલોની ચર્ચા કરે છે. તમને તે ઉપયોગી થશે! આ વિડિઓ તપાસો  ",
  },
  "cropPage.contentVideo.agrostarAppShareText": {
    en: "🌾 🎥 Also you can see more such videos here  ",
    mr: "🌾 🎥 तसेच आपण असे आणखी व्हिडिओ येथे पाहू शकता  ",
    hi: "🌾 🎥 साथ ही आप इस तरह के और भी वीडियो यहाँ देख सकते हैं ",
    gu: "🌾 🎥 ઉપરાંત તમે અહીં આવી વધુ વિડિઓઝ જોઈ શકો છો ",
  },
  "cropPage.cropHeader.scheduledCountTitle": {
    en: "Scheduled Classes",
    mr: "आगामी क्लास",
    hi: "आगामी क्लासेस",
    gu: "આગામી ચર્ચા-સત્ર",
  },
  "cropPage.cropHeader.videosCountTitle": {
    en: "Videos",
    mr: "व्हिडिओ",
    hi: "व्हिडिओ",
    gu: "વિડિઓઝ",
  },
  "dashboard.cropsList.showMore": {
    en: "See more",
    mr: "अजून पहा",
    hi: "और देखें",
    gu: "વધુ જુવો ",
  },
  "dashboard.cropsList.title": {
    en: "Watch guidance videos",
    mr: "मार्गदर्शन व्हिडिओ पहा",
    hi: "मार्गदर्शन वीडियो देखें",
    gu: "માર્ગદર્શન વિડિઓ જુઓ",
  },
  "dashboard.cropsList.liveHelpContainerTitle": {
    en: "Video Calling",
    mr: "व्हिडिओ कॉलिंग",
    hi: "वीडियो कॉलिंग",
    gu: "વિડિઓ કોલિંગ",
  },
  "cropPage.contentVideo.newTag": {
    en: "New",
    mr: "नवीन",
    hi: "नया",
    gu: "નવું",
  },
  "cropPage.contentVideo.nextVideo": {
    en: "Next",
    mr: "पुढे",
    hi: "अगला",
    gu: "આગળ",
  },
  "cropPage.contentVideo.previousVideo": {
    en: "Previous",
    mr: "मागे",
    hi: "पिछला",
    gu: "પૂર્વ",
  },
  "dashboard.allClasses.seeAllClassesButton": {
    en: "See all upcoming classes",
    mr: "सर्व आगामी वर्ग पहा",
    hi: "सभी आगामी क्लासेस देखे",
    gu: "આગામી કલાસ્સેસ જુઓ",
  },
  "dashboard.live.ongoing": {
    en: "Ongoing",
    mr: "चालू आहे",
    hi: "चालू है",
    gu: "ચાલુ છે",
  },
  "cropPage.upcoming.shareText1": {
    en: "On",
    mr: "वर",
    hi: "पर",
    gu: "પર",
  },
  "cropPage.upcoming.shareText2": {
    en: "AgroStar Gold Online Class",
    mr: "साठी अ‍ॅग्रोस्टार गोल्ड ऑनलाइन क्लास",
    hi: "के लिए एग्रोस्टार गोल्ड ऑनलाइन क्लास",
    gu: "માટે એગ્રોસ્ટાર ગોલ્ડ ઓનલાઈન ક્લાસ",
  },
  "cropPage.upcoming.shareText3": {
    en: "Please click on this link below and go to Gold section on App to join the class 👇👇👇👇",
    mr: "रोजी अनुसूचित करण्यात आला आहे. कृपया खालील लिंक वर क्लिक करा आणि वर्गात सामील होण्यासाठी अ‍ॅपवरील गोल्ड विभागात जा 👇👇👇👇",
    hi: "को निर्धारित है। कृपया नीचे दिए गए इस लिंक पर क्लिक करें और कक्षा में शामिल होने के लिए ऐप पर गोल्ड सेक्शन में जाएं 👇👇👇👇",
    gu: "નું આયોજન કરેલું છે. નીચે આપેલી લિન્ક પર ક્લિક કરો અને એપ્લીકેશન ના ગોલ્ડ વિભાગ માં જઈને ક્લાસ માં જોડાઓ 👇👇👇👇",
  },
  "cropPage.recording.shareText1": {
    en: "For",
    mr: "साठी",
    hi: "के लिए",
    gu: "માટે",
  },
  "cropPage.recording.shareText2": {
    en: "has been recorded and is available for viewing on Agrostar App. To view this recording please click on the link below and go to Gold section on the app 👇👇👇👇",
    mr: " या विषयावर अग्रोस्टार गोल्ड ऑनलाईन क्लास रेकॉर्ड केला गेला आहे आणि तो अ‍ॅग्रोस्टार अ‍ॅपवर पाहण्यासाठी उपलब्ध आहे. हे रेकॉर्डिंग पाहण्यासाठी कृपया खालील लिंकवर क्लिक करा आणि अ‍ॅपवरील गोल्ड विभागात जा 👇👇👇👇",
    hi: "विषय पर एग्रोस्टार गोल्ड ऑनलाइन क्लास रिकॉर्ड किया गया है और यह एग्रोस्टार ऐप पर देखने के लिए उपलब्ध है। इस रिकॉर्डिंग को देखने के लिए कृपया नीचे दिए गए लिंक पर क्लिक करें और ऐप पर गोल्ड सेक्शन में जाएं 👇👇👇👇",
    gu: "વિષય પર એગ્રોસ્ટાર ગોલ્ડ ઓનલાઈન ક્લાસ રેકોર્ડ કરવામાં આવ્યો છે અને એગ્રોસ્ટાર એપ પર જોવા માટે ઉપલબ્ધ છે. આ રેકોર્ડિંગ જોવા માટે કૃપા કરીને નીચે આપેલી લિન્ક પર ક્લિક કરો અને એપ્લીકેશન ના ગોલ્ડ વિભાગ માં જાઓ 👇👇👇👇",
  },
  "cropPage.contentVideo.productsInTheVideo": {
    en: "Products in this video",
    mr: "या व्हिडिओमधील उत्पादने",
    hi: "इस वीडियो में उत्पाद",
    gu: "આ વિડિઓમાં ઉત્પાદનો",
  },
  "cropPage.contentVideo.clickHereSKU": {
    en: "Click here",
    mr: "क्लिक करा",
    hi: "क्लिक करें",
    gu: "ક્લિક કરો",
  },
  // *********************************************************************************
};
